import { ManageInvestorDetailsContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/InvestorDetails';
import { useInvestorDocumentWorkflowList } from '@dealstack/frontend/app/pages/Project/MIP/hooks';
import { useContext, useMemo } from 'react';
import {
	DocumentSigningScope,
	DocumentWorkflowInstanceSignatureStatus,
	DocumentWorkflowInstanceStatus,
} from '@dealstack/shared/lib/generated';

export const useDocumentWorkflowDashcard = () => {
	const manageInvestorDetailsController = useContext(ManageInvestorDetailsContext);
	const { investorId } = manageInvestorDetailsController;
	const documentsQuery = useInvestorDocumentWorkflowList(investorId);

	const { requestedDocument, suppliedDocument, fullyExecuted, completeStatus } = useMemo(() => {
		const documents = documentsQuery.data?.payload?.documents ?? [];
		const signatoryDocuments = documents.filter((doc) => !doc.isPlainDocument);

		const requested = signatoryDocuments.length;

		const signed = signatoryDocuments.filter((doc) => {
			if (doc.signingScope === DocumentSigningScope.ALL_PARTICIPANTS) {
				const signedCount = doc.investorSignature.signedCount ?? 0;
				const totalCount = doc.investorSignature.totalCount ?? 0;
				return totalCount > 0 && signedCount === totalCount;
			}
			const status = doc.investorSignature.status;
			return (
				status === DocumentWorkflowInstanceSignatureStatus.SIGNED ||
				status === DocumentWorkflowInstanceSignatureStatus.COMPLETED
			);
		}).length;

		const fullyExec = signatoryDocuments.filter(
			(doc) => doc.workflowStatus === DocumentWorkflowInstanceStatus.COMPLETED
		).length;

		const complete = fullyExec === requested && requested !== 0;

		return {
			requestedDocument: requested,
			suppliedDocument: signed,
			fullyExecuted: fullyExec,
			completeStatus: complete,
		};
	}, [documentsQuery.data?.payload?.documents]);

	return {
		manageInvestorDetailsController,
		requestedDocument,
		suppliedDocument,
		fullyExecuted,
		completeStatus,
	};
};
